<template>
  <v-toolbar flat class="mb-4">
    <v-toolbar-title>
      {{ title }}
      <span></span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            fab
            small
            color="primary"
            router
            to="/tag"
            v-on="on"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("common.back") }}</span>
      </v-tooltip>
    </div>
  </v-toolbar>
</template>

<script>
export default {
  name: "TagDetailToolbar",
  props: {
    title: String,
  },
};
</script>

<style>
</style>